<template>
  <div v-bind="$attrs" :class="['ews-select', outerClass, $attrs?.class || ''].join(' ')">
    <label v-if="label" :class="labelClass">{{ label }}</label>
    <div :class="['ews-select-wrapper', wrapperClass].join(' ')">
      <div :class="['ews-select-inner', innerClass].join(' ')">
        <form-antd-select
          v-bind="antDesignProps || {}"
          :allowClear="allowClear"
          :labelInValue="labelInValue !== undefined ? labelInValue : true"
          :searchable="searchable"
          :multiple="multiple"
          :mode="multiple ? 'multiple' : ''"
          :trackBy="trackBy"
          :options="options"
          :modelValue="modelValue"
          @update:value="updateModelValue"
          :placeholder="placeholder || ''"
          :class="['form-select block', inputClass].join(' ')"
          data-lpignore="true"
        >
          <template v-for="(_, name) in $slots" #[name]="slotData">
            <slot :name="name" v-bind="slotData" />
          </template>
        </form-antd-select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormSelect',
  inheritAttrs: false,
  props: {
    /**
     * Current value of select component.
     * @model
     */
    modelValue: {
      type: [Number, String, Array, Object],
      default: () => ''
    },
    /**
     * Array of available options: Objects, Strings or Integers. If array of objects, visible label will default to option.label.
     */
    options: {
      type: [Object, Array],
      required: true
    },
    /**
     * Unique field used to compare objects. Only use if options are objects.
     */
    trackBy: {
      type: String
    },
    /**
     * Disable the select as being searchable.
     */
    searchable: {
      type: Boolean,
      default: true
    },
    /**
     * Enable multi-select options.
     */
    multiple: {
      type: Boolean,
      default: false
    },
    /**
     * Label that will be visible above the dropdown.
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * Decide whether to show labels on highlighted options.
     */
    showLabels: {
      type: Boolean,
      default: false
    },
    /**
     * String to display when no option is selected.
     */
    placeholder: {
      type: String,
      default: 'Select one'
    },
    /**
     * Additional classes for the wrapper.
     */
    wrapperClass: {
      type: String,
      default: ''
    },
    /**
     * Additional classes for the outer.
     */
    outerClass: {
      type: String,
      default: ''
    },
    /**
     * Additional classes for the inner.
     */
    innerClass: {
      type: String,
      default: 'w-full'
    },
    /**
     * Additional classes for the input.
     */
    inputClass: {
      type: String,
      default: 'w-full'
    },
    /**
     * Additional classes for the label.
     */
    labelClass: {
      type: String,
      default: 'text-gray-700 font-semibold text-base ml-2 mb-1 inline-block'
    },
    /**
     * Additional classes for help text.
     */
    helpClass: {
      type: String,
      default: 'text-cool-gray-500 font-light text-sm ml-1'
    },
    /**
     * Additional classes for error text.
     */
    errorClass: {
      type: String,
      default: 'text-red-700 font-light text-sm ml-1'
    },
    /**
     * Ant Design Props.
     */
    antDesignProps: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  emits: ['update:modelValue', 'object'],
  computed: {
    _value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  methods: {
    async updateModelValue(value) {
      this.$emit('update:modelValue', value)
    },
    async triggerObjectValue(value) {
      this.$emit('object', value)
    }
  }
}
</script>
